// Promo Card Getters

export const getPromoCardList = state => {
  return state.promoCardList
}

export const getPromoCardInfo = state => {
  return state.promoCardInfo
}
